/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateSectorCommand } from '../../models/update-sector-command';
import { UpdateSectorCommandResult } from '../../models/update-sector-command-result';

export interface ApiSectorUpdateSectorPatch$Params {
      body?: UpdateSectorCommand
}

export function apiSectorUpdateSectorPatch(http: HttpClient, rootUrl: string, params?: ApiSectorUpdateSectorPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSectorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiSectorUpdateSectorPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateSectorCommandResult>;
    })
  );
}

apiSectorUpdateSectorPatch.PATH = '/api/Sector/UpdateSector';
